module.exports = __webpack_public_path__ + "img/whatsapp.522f5df5.svg";